import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { FMIcon } from 'atoms';
import style from './Buttons.style';

const FMSelectButton = (props: any) => {
    const { classes, ...other } = props;

    return (
        <Button className={classes.selectButton} {...other}>
            <span className={classes.buttonLabel}>
                {props.children}
            </span>
            <FMIcon type="arrowdropdown" color={props.color} />
        </Button>
    );
};

export default withStyles(style)(FMSelectButton);
